module.exports = __webpack_public_path__ + "media/images/comments-b746fb6c3ffb70253e84e4afcc4661a1.svg";